import useScreenIsLess from '@hooks/useScreenIsLess'

const tabletScreenWidth = 1024

const useIsTablet = (): boolean => useScreenIsLess(tabletScreenWidth)

export default useIsTablet
